export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
}

export enum HttpStatusCode {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  FORBIDDEN = 403,
  INTERNAL_SERVER_ERROR = 500,
}

export enum Category {
  Any = 'CAT_ANY',
  AnyDiagnostic = 'CAT_ANY_DIAGNOSTIC',
  Nips = 'CAT000252',
}
